/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".full-screen[_ngcontent-%COMP%]{position:fixed;width:100%;height:100%;top:0;left:0;z-index:9999;background-color:rgba(0,0,0,.3)}.full-screen[_ngcontent-%COMP%]   .spinner[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translateY(-50%)}"];
export { styles as styles };

